const getAnalytics = () => {
	return window.analytics
}

export const productAddedToWishlist = (props) => {
    const a = getAnalytics()
	if (a) {
		a.track(
			'Product Added to Wishlist',
			props || {},
		)
	}
}

export const productClicked = (props) => {
    const a = getAnalytics()
	if (a) {
		a.track(
			'Product Clicked',
			props || {},
		)
	}
}

export const productListFiltered = (props) => {
    const a = getAnalytics()
	if (a) {
		a.track(
			'Product List Filtered',
			props || {},
		)
	}
}

export const productListViewed = (props) => {
    const a = getAnalytics()
	if (a) {
		a.track(
			'Product List Viewed',
			props || {},
		)
	}
}

export const productRemovedFromWishlist = (props) => {
    const a = getAnalytics();
    if (a) {
        a.track(
            'Product Removed from Wishlist',
            props || {},
        )
    }
}

export const productsSearched = (props) => {
    const a = getAnalytics();
    if (a) {
        a.track(
            'Products Searched',
            props || {},
        )
    }
}

export const productViewed = (props) => {
	const a = getAnalytics()
	if (a) {
		a.track(
			'Product Viewed',
			props || {},
        )
    }
}

export const wishlistCreated = (props) => {
    const a = getAnalytics();
    if (a) {
        a.track(
			'Wishlist Created',
            props || {},
        )
    }
}

export const wishlistProductAddedToCart = (props) => {
	const a = getAnalytics()
	if (a) {
		a.track(
			'Wishlist Product Added to Cart',
			props || {},
		)
	}
}